import './style.scss';
import 'vite/modulepreload-polyfill';

// --------------------------------------------------------
// The `client` module is injected by the `typo3-bundle`
// plugin during build, and runtime. It provides a variable
// `components`, which contains an alphabetically ordered
// list of component names, build using the pattern
// `src/components/*/[COMPONENT].ts`.
//
// There is no need to create this list manually anymore.
// If you need a different order, simply sort it.
// Example for sorting by priority:
//
// console.log(components);
// >>> [ "accordion", "demo", "footer", "header", "react" ]
//
// const priorities = [ 'header', 'footer' ];
// const sortedComponents = components.sort(
//   (c1, c2) => priorities.indexOf(c1) - priorities.indexOf(c2)
// );
//
// console.log(sortedComponents);
// >>> [ "header", "footer", "accordion", "demo", "react" ]
// --------------------------------------------------------
// XXX: DO NOT REMOVE THE FOLLOWING TWO LINES!
import client from '@brandung/vite-plugin-typo3-bundle/client';
const components = client.components;

console.log('[components]', components);

// Detects if a component is used on the page and initializes it.
(async () => {
  // Dynamic importing of the component, if component is detected on the page
  // The folder name and file name of the component has to be the same as the class name
  console.log('[initializing] main.ts');
  for (const component of components) {
    if (!document.querySelector(`.${component}`)) continue;
    console.log(`[detected] ${component} component`);
    try {
      const module = await import(`./components/${component}/${component}`);
      if (module?.init) {
        module.init();
      }
    } catch (e) {
      console.error(`[error] error while loading ${component}`);
      console.error(e);
    }
  }
})();
